/* ============================================================
   DOGS SUPREME · <ds-article-video>
   Gekapseltes Custom Element fuer Video im Artikel (Standard fuer
   JEDE kuenftige Video-Einbettung im Blog, erstmals Kuehlmatte-Artikel).

   Look: Apple Liquid Glass (iOS-26-Formsprache) auf dunklem Video-Glas:
     · Stage mit 18px-Radius, Poster, kein natives Control-Chrome
     · Center-Play als Glas-Kreis, Bottom-Bar als Glas-Pille
       (Play/Pause · Zeit · Scrubber · Restzeit)
     · Ton-Chip oben rechts, solange stumm ("Ton an", 1 Tap)
     · Conversion-CTA-Pille (data-cta-*) erscheint nach dem ersten
       Durchlauf; Klick laeuft als normaler Artikel-Link und oeffnet
       damit die Produkt-VORSCHAU (ds-article.js)

   Verhalten:
     · Autoplay stumm NUR im Viewport (IntersectionObserver),
       Pause beim Rausscrollen, Resume nur ohne Nutzer-Pause
     · prefers-reduced-motion: KEIN Autoplay, Poster + Play
     · Controls blenden beim Abspielen nach 2,4 s aus, Tap holt sie zurueck
     · Mehrere Instanzen: nur eine spielt mit Ton (Courtesy-Pause)

   Fallback ohne JS: das innere <video controls> bleibt voll bedienbar,
   das Element ruestet nur auf (controls-Attribut wird beim Upgrade entfernt).

   Kompatibilitaet wie ds-audio.js: echte ES2015-class, kein Optional
   Chaining, keine #-Felder, Feature-Erkennung, graceful Degradation.
   ============================================================ */
(function () {
  'use strict';
  if (!('customElements' in window) || customElements.get('ds-article-video')) return;

  function fmt(t) {
    if (!isFinite(t) || t < 0) t = 0;
    t = Math.floor(t);
    var s = t % 60;
    return Math.floor(t / 60) + ':' + (s < 10 ? '0' + s : '' + s);
  }
  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  var INSTANCES = [];

  function injectStyles() {
    if (document.getElementById('ds-video-styles')) return;
    var style = document.createElement('style');
    style.id = 'ds-video-styles';
    style.textContent = [
      /* Figure-Standard (ersetzt die frueheren Inline-Styles im Artikel) */
      ".ds-vid{margin:34px auto;max-width:360px;text-align:center}",
      ".ds-vid__cap{margin-top:12px;font-size:.9em;color:#5a6470;line-height:1.55;text-align:left}",
      ".ds-vid__hint{font-size:.8em;color:#8a929c}",
      "ds-article-video[data-orientation=\"landscape\"]{max-width:640px}",
      "figure.ds-vid:has(ds-article-video[data-orientation=\"landscape\"]){max-width:640px}",

      "ds-article-video{",
      "--dg:rgba(28,28,30,.55);--dg-bd:rgba(255,255,255,.14);--dg-hi:inset 0 1px 0 rgba(255,255,255,.18);",
      "--lg:rgba(255,255,255,.86);--lg-bd:rgba(0,0,0,.07);--txt:#1d1d1f;--on:rgba(255,255,255,.95);",
      "--ff:-apple-system,'SF Pro Text','SF Pro Display',system-ui,sans-serif;",
      "display:block;position:relative;font-family:var(--ff)}",
      "ds-article-video *{box-sizing:border-box}",

      "ds-article-video .dsv-stage{position:relative;border-radius:18px;overflow:hidden;background:#000;",
      "box-shadow:0 10px 34px rgba(0,0,0,.16);transform:translateZ(0)}",
      "ds-article-video video{display:block;width:100%;height:auto;background:#000}",

      "ds-article-video .dsv-hit{position:absolute;top:0;left:0;width:100%;height:100%;",
      "border:0;margin:0;padding:0;background:transparent;cursor:pointer;-webkit-tap-highlight-color:transparent}",

      "ds-article-video .dsv-center{position:absolute;top:50%;left:50%;width:64px;height:64px;margin:-32px 0 0 -32px;",
      "display:flex;align-items:center;justify-content:center;border:.5px solid var(--dg-bd);border-radius:50%;",
      "background:var(--dg);-webkit-backdrop-filter:blur(18px) saturate(160%);backdrop-filter:blur(18px) saturate(160%);",
      "box-shadow:var(--dg-hi),0 6px 20px rgba(0,0,0,.30);color:var(--on);pointer-events:none;",
      "transition:opacity .35s ease,transform .35s cubic-bezier(.32,.72,0,1)}",
      "ds-article-video[data-state=\"playing\"] .dsv-center{opacity:0;transform:scale(.72)}",
      "ds-article-video .dsv-center svg{display:block;margin-left:4px}",

      "ds-article-video .dsv-spin{position:absolute;top:50%;left:50%;width:34px;height:34px;margin:-17px 0 0 -17px;",
      "border-radius:50%;border:2.5px solid rgba(255,255,255,.28);border-top-color:rgba(255,255,255,.9);",
      "animation:dsv-rot .8s linear infinite;opacity:0;pointer-events:none;transition:opacity .2s}",
      "ds-article-video[data-buffering=\"1\"] .dsv-spin{opacity:1}",
      "@keyframes dsv-rot{to{transform:rotate(360deg)}}",

      "ds-article-video .dsv-sound{position:absolute;top:10px;right:10px;display:inline-flex;align-items:center;gap:6px;",
      "height:32px;padding:0 12px;border:.5px solid var(--dg-bd);border-radius:999px;background:var(--dg);",
      "-webkit-backdrop-filter:blur(18px) saturate(160%);backdrop-filter:blur(18px) saturate(160%);",
      "box-shadow:var(--dg-hi);color:var(--on);font-size:12.5px;font-weight:600;letter-spacing:.01em;",
      "cursor:pointer;transition:opacity .3s ease;-webkit-tap-highlight-color:transparent}",
      "ds-article-video .dsv-sound svg{display:block}",
      "ds-article-video .dsv-sound .dsv-sound-txt{line-height:1}",
      "ds-article-video[data-muted=\"0\"] .dsv-sound{padding:0;width:32px;justify-content:center}",
      "ds-article-video[data-muted=\"0\"] .dsv-sound .dsv-sound-txt{display:none}",

      "ds-article-video .dsv-bar{position:absolute;left:10px;right:10px;bottom:10px;display:flex;align-items:center;gap:10px;",
      "height:40px;padding:0 12px;border:.5px solid var(--dg-bd);border-radius:999px;background:var(--dg);",
      "-webkit-backdrop-filter:blur(18px) saturate(160%);backdrop-filter:blur(18px) saturate(160%);",
      "box-shadow:var(--dg-hi),0 4px 14px rgba(0,0,0,.22);color:var(--on);",
      "transition:opacity .35s ease,transform .35s ease}",
      "ds-article-video[data-controls=\"0\"] .dsv-bar{opacity:0;transform:translateY(6px);pointer-events:none}",
      "ds-article-video[data-controls=\"0\"] .dsv-sound{opacity:0;pointer-events:none}",
      "ds-article-video[data-muted=\"1\"][data-controls=\"0\"] .dsv-sound{opacity:1;pointer-events:auto}",
      "ds-article-video .dsv-btn{flex:0 0 auto;display:flex;align-items:center;justify-content:center;width:28px;height:28px;",
      "border:0;padding:0;margin:0;background:transparent;color:var(--on);cursor:pointer;-webkit-tap-highlight-color:transparent}",
      "ds-article-video .dsv-time{flex:0 0 auto;font-size:11.5px;font-variant-numeric:tabular-nums;opacity:.92;min-width:34px;text-align:center}",

      "ds-article-video .dsv-range{flex:1 1 auto;-webkit-appearance:none;appearance:none;height:20px;margin:0;",
      "background:transparent;cursor:pointer;min-width:40px}",
      "ds-article-video .dsv-range::-webkit-slider-runnable-track{height:4px;border-radius:2px;",
      "background:linear-gradient(to right,rgba(255,255,255,.95) 0%,rgba(255,255,255,.95) var(--p,0%),rgba(255,255,255,.28) var(--p,0%))}",
      "ds-article-video .dsv-range::-webkit-slider-thumb{-webkit-appearance:none;width:12px;height:12px;border-radius:50%;",
      "background:#fff;box-shadow:0 1px 4px rgba(0,0,0,.35);margin-top:-4px}",
      "ds-article-video .dsv-range::-moz-range-track{height:4px;border-radius:2px;background:rgba(255,255,255,.28)}",
      "ds-article-video .dsv-range::-moz-range-progress{height:4px;border-radius:2px;background:rgba(255,255,255,.95)}",
      "ds-article-video .dsv-range::-moz-range-thumb{width:12px;height:12px;border:0;border-radius:50%;background:#fff;box-shadow:0 1px 4px rgba(0,0,0,.35)}",
      "ds-article-video .dsv-range:focus{outline:none}",
      "ds-article-video .dsv-range:focus-visible{outline:2px solid #fff;outline-offset:2px;border-radius:4px}",

      "ds-article-video .dsv-cta{position:absolute;left:50%;bottom:62px;transform:translate(-50%,10px);",
      "display:inline-flex;align-items:center;gap:6px;height:36px;padding:0 16px;border:.5px solid var(--lg-bd);",
      "border-radius:999px;background:var(--lg);-webkit-backdrop-filter:blur(18px) saturate(160%);backdrop-filter:blur(18px) saturate(160%);",
      "box-shadow:inset 0 1px 0 rgba(255,255,255,.65),0 6px 18px rgba(0,0,0,.22);color:var(--txt);",
      "font-size:13.5px;font-weight:600;text-decoration:none;white-space:nowrap;opacity:0;pointer-events:none;",
      "transition:opacity .45s ease,transform .45s cubic-bezier(.32,.72,0,1)}",
      "ds-article-video[data-cta=\"1\"] .dsv-cta{opacity:1;transform:translate(-50%,0);pointer-events:auto}",
      "ds-article-video .dsv-cta svg{display:block;color:#0066cc}",

      "@media (prefers-reduced-motion:reduce){",
      "ds-article-video .dsv-center,ds-article-video .dsv-bar,ds-article-video .dsv-cta,ds-article-video .dsv-sound{transition:none}",
      "ds-article-video .dsv-spin{animation-duration:1.6s}}",

      "@media (prefers-reduced-transparency:reduce){",
      "ds-article-video{--dg:rgba(28,28,30,.92);--lg:rgba(255,255,255,.97)}}"
    ].join('');
    document.head.appendChild(style);
  }

  var SVG = {
    play: '<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13l11-6.5z"/></svg>',
    playSm: '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13l11-6.5z"/></svg>',
    pauseSm: '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M7 5h3.4v14H7zm6.6 0H17v14h-3.4z"/></svg>',
    soundOff: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4z"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>',
    soundOn: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18.5 5.5a9.5 9.5 0 0 1 0 13"/></svg>',
    chev: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>'
  };

  class DsArticleVideo extends HTMLElement {
    connectedCallback() {
      if (this._wired) return;
      var video = this.querySelector('video');
      if (!video) return;
      this._wired = true;
      injectStyles();
      INSTANCES.push(this);
      this._build(video);
    }

    _build(video) {
      this.video = video;
      this.userPaused = false;
      this.loops = 0;
      this.lastT = 0;
      this.hideTimer = null;
      this.ctaShown = false;

      /* Upgrade: natives Chrome weg, unsere Attribute setzen */
      video.removeAttribute('controls');
      video.setAttribute('playsinline', '');
      video.muted = true;
      if (!video.hasAttribute('preload')) video.setAttribute('preload', 'metadata');

      var w = parseInt(video.getAttribute('width') || '0', 10);
      var h = parseInt(video.getAttribute('height') || '0', 10);
      if (w && h) this.setAttribute('data-orientation', w >= h ? 'landscape' : 'portrait');

      /* DOM: Stage um das Video bauen (alle Overlay-Markups sind statische
         Konstanten, einzige dynamische Werte laufen ueber textContent/Attribute) */
      var stage = document.createElement('div');
      stage.className = 'dsv-stage';
      this.insertBefore(stage, video);
      stage.appendChild(video);

      stage.insertAdjacentHTML('beforeend', [
        '<button type="button" class="dsv-hit" aria-label="Video abspielen oder pausieren"></button>',
        '<div class="dsv-center" aria-hidden="true">' + SVG.play + '</div>',
        '<div class="dsv-spin" aria-hidden="true"></div>',
        '<button type="button" class="dsv-sound" aria-label="Ton einschalten">' + SVG.soundOff + '<span class="dsv-sound-txt">Ton an</span></button>',
        '<div class="dsv-bar">',
        '<button type="button" class="dsv-btn dsv-toggle" aria-label="Abspielen">' + SVG.playSm + '</button>',
        '<span class="dsv-time dsv-cur">0:00</span>',
        '<input type="range" class="dsv-range" min="0" max="100" step="0.1" value="0" aria-label="Video-Fortschritt">',
        '<span class="dsv-time dsv-dur">–:––</span>',
        '</div>'
      ].join(''));

      if (this.dataset.ctaHref && this.dataset.ctaLabel) {
        var cta = document.createElement('a');
        cta.className = 'dsv-cta';
        cta.href = this.dataset.ctaHref;
        if (this.dataset.ctaEvent) cta.setAttribute('data-event', this.dataset.ctaEvent);
        cta.textContent = this.dataset.ctaLabel;
        cta.insertAdjacentHTML('beforeend', SVG.chev);
        stage.appendChild(cta);
      }

      this.els = {
        stage: stage,
        hit: stage.querySelector('.dsv-hit'),
        sound: stage.querySelector('.dsv-sound'),
        toggle: stage.querySelector('.dsv-toggle'),
        cur: stage.querySelector('.dsv-cur'),
        dur: stage.querySelector('.dsv-dur'),
        range: stage.querySelector('.dsv-range')
      };

      this.setAttribute('data-state', 'idle');
      this.setAttribute('data-muted', '1');
      this.setAttribute('data-controls', '1');

      this._wireEvents();
      this._wireObserver();
    }

    _wireEvents() {
      var self = this, v = this.video, els = this.els;

      els.hit.addEventListener('click', function () { self._toggle(true); });
      els.toggle.addEventListener('click', function () { self._toggle(true); });

      els.sound.addEventListener('click', function () {
        var willUnmute = v.muted;
        v.muted = !v.muted;
        self.setAttribute('data-muted', v.muted ? '1' : '0');
        els.sound.innerHTML = (v.muted ? SVG.soundOff : SVG.soundOn) + '<span class="dsv-sound-txt">Ton an</span>';
        els.sound.setAttribute('aria-label', v.muted ? 'Ton einschalten' : 'Ton ausschalten');
        if (willUnmute) {
          self._pauseOthers();
          if (v.paused) self._play();
        }
        self._poke();
      });

      els.range.addEventListener('input', function () {
        if (isFinite(v.duration) && v.duration > 0) {
          v.currentTime = (parseFloat(els.range.value) / 100) * v.duration;
          self._paint();
        }
        self._poke();
      });

      v.addEventListener('loadedmetadata', function () {
        els.dur.textContent = fmt(v.duration);
        if (v.videoWidth && v.videoHeight) {
          self.setAttribute('data-orientation', v.videoWidth >= v.videoHeight ? 'landscape' : 'portrait');
        }
      });
      v.addEventListener('timeupdate', function () { self._paint(); self._loopWatch(); });
      v.addEventListener('play', function () { self._onPlay(); });
      v.addEventListener('pause', function () { self._onPause(); });
      v.addEventListener('waiting', function () { self.setAttribute('data-buffering', '1'); });
      v.addEventListener('playing', function () { self.removeAttribute('data-buffering'); });
      v.addEventListener('ended', function () { self._showCta(); });
    }

    _wireObserver() {
      var self = this;
      if (!('IntersectionObserver' in window) || reduceMotion()) return;
      this.io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        if (!e) return;
        if (e.intersectionRatio >= 0.5) {
          if (!self.userPaused && self.video.paused) self._play();
        } else if (e.intersectionRatio < 0.35 && !self.video.paused) {
          self.video.pause();
        }
      }, { threshold: [0, 0.35, 0.5, 0.75] });
      this.io.observe(this);
    }

    _toggle(byUser) {
      if (this.video.paused) {
        if (byUser) this.userPaused = false;
        this._play();
      } else {
        if (byUser) this.userPaused = true;
        this.video.pause();
      }
      this._poke();
    }

    _play() {
      if (!this.video.muted) this._pauseOthers();
      var p = this.video.play();
      if (p && p.catch) p.catch(function () { /* Autoplay verweigert -> Poster + Play bleibt stehen */ });
    }

    _onPlay() {
      this.setAttribute('data-state', 'playing');
      this.els.toggle.innerHTML = SVG.pauseSm;
      this.els.toggle.setAttribute('aria-label', 'Pausieren');
      if (!this._startTracked) {
        this._startTracked = true;
        if (window.dataLayer) window.dataLayer.push({ event: 'ds_video_start', ds_video: (this.video.currentSrc || '').split('/').pop() });
      }
      this._poke();
    }

    _onPause() {
      this.setAttribute('data-state', this.video.currentTime > 0 ? 'paused' : 'idle');
      this.els.toggle.innerHTML = SVG.playSm;
      this.els.toggle.setAttribute('aria-label', 'Abspielen');
      this._showControls();
    }

    /* CTA-Timing (GF 11.07.): frueh zeigen, aber die Szene erst landen
       lassen. Default 3 s Wiedergabe, pro Video via data-cta-after="N"
       uebersteuerbar. Loop-Erkennung (Zeitsprung nach vorn-unten, weil
       das loop-Attribut 'ended' schluckt) bleibt als frueherer Trigger
       fuer sehr kurze Videos. */
    _loopWatch() {
      var t = this.video.currentTime;
      if (t + 1 < this.lastT) {
        this.loops++;
        if (this.loops >= 1) this._showCta();
      }
      this.lastT = t;
      var after = parseFloat(this.dataset.ctaAfter);
      if (!isFinite(after) || after <= 0) after = 3;
      if (!this.ctaShown && t > after) this._showCta();
    }

    _showCta() {
      if (this.ctaShown || !this.dataset.ctaHref) return;
      this.ctaShown = true;
      this.setAttribute('data-cta', '1');
      if (window.dataLayer) window.dataLayer.push({ event: 'ds_video_cta_shown', ds_video_cta: this.dataset.ctaHref.split('?')[0] });
    }

    _pauseOthers() {
      for (var i = 0; i < INSTANCES.length; i++) {
        var inst = INSTANCES[i];
        if (inst !== this && inst.video && !inst.video.paused && !inst.video.muted) inst.video.pause();
      }
    }

    _paint() {
      var v = this.video;
      if (!isFinite(v.duration) || v.duration <= 0) return;
      var pct = (v.currentTime / v.duration) * 100;
      this.els.range.value = String(pct);
      this.els.range.style.setProperty('--p', pct + '%');
      this.els.cur.textContent = fmt(v.currentTime);
      this.els.dur.textContent = fmt(v.duration);
    }

    /* Controls-Sichtbarkeit: beim Abspielen nach 2,4 s ausblenden */
    _showControls() {
      this.setAttribute('data-controls', '1');
      if (this.hideTimer) { clearTimeout(this.hideTimer); this.hideTimer = null; }
    }

    _poke() {
      var self = this;
      this._showControls();
      this.hideTimer = setTimeout(function () {
        if (!self.video.paused) self.setAttribute('data-controls', '0');
      }, 2400);
    }
  }

  customElements.define('ds-article-video', DsArticleVideo);
})();
